var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6548 2.29456L12.9885 13.1018C12.9494 13.3552 12.7965 13.5761 12.5727 13.7019C12.4466 13.7727 12.3053 13.8085 12.1645 13.8085C12.0555 13.8085 11.9479 13.7873 11.8445 13.7442L8.65261 12.4138L7.32846 14.4C7.22692 14.5738 7.05769 14.6649 6.87545 14.6649C6.57604 14.6649 6.33391 14.4228 6.33391 14.1234V11.6193C6.33391 11.4341 6.39567 11.254 6.50944 11.108L12.1658 3.83428L4.51926 10.7154L1.8478 9.60106C1.55485 9.4787 1.35632 9.20273 1.33679 8.86167C1.31727 8.52061 1.47918 8.24411 1.75492 8.0866L13.4187 1.44503C13.697 1.28598 14.0404 1.30061 14.3039 1.48164C14.5673 1.66266 14.7042 1.97849 14.6548 2.29456Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d91b0f52cb10abd713fbeeecbf32016b.svg";
export { ForwardRef as ReactComponent };